import React, { useEffect, useState } from "react";
import { Table } from "antd";
import { getData } from "../../../api/api";
import { useStorage } from "../../../hooks/useLocalStorage";
import { useParams } from "react-router-dom";

export default function Group() {
  const [groups, setGroups] = useState([]);
  const [loading, setLoading] = useState(false);
  const [user, setUser, loadUser] = useStorage("use", null);
  const { id } = useParams();
  

  useEffect(() => {
    setLoading(true);
    getData(
      `/retreat-groups?retreatId=${id}&participantId=${user.id}&pageNumber=0&pageSize=10`
    )
      .then((response) => {
        setGroups(response?.data?.data || []);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching groups:", error);
        setLoading(false);
      });
  }, []);
  console.log("====================================");
  console.log(groups);
  console.log("====================================");
  // Định nghĩa cột cho bảng thành viên
  const memberColumns = [
    {
      title: "First Name",
      dataIndex: ["member", "firstName"],
      key: "firstName",
    },
    {
      title: "Last Name",
      dataIndex: ["member", "lastName"],
      key: "lastName",
    },
    {
      title: "Email",
      dataIndex: ["member", "email"],
      key: "email",
    },
    {
      title: "Gender",
      dataIndex: ["member", "gender"],
      key: "gender",
    },
    // Bạn có thể thêm các cột khác nếu cần
  ];

  return (
    <div>
      {loading ? (
        <p>Loading groups...</p>
      ) : (
        groups.map((group) => (
          <div key={group.id} style={{ marginBottom: "40px" }}>
            <h2>{group.name}</h2>
            {/* Hiển thị thông tin phòng nếu cần */}
            <p>Room: {group.room?.name || "N/A"}</p>
            {group?.monk?.firstName && (
              <p>
                Monk: {group?.monk?.firstName + " " + group?.monk?.lastName}
              </p>
            )}
            <Table
              dataSource={group.retreatGroupMembers}
              columns={memberColumns}
              rowKey="id"
              scroll={{ x: true }}
              //   pagination={false}
            />
          </div>
        ))
      )}
    </div>
  );
}
